var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-btn-group"},[_c('Button',{staticClass:"cancle",on:{"click":function($event){return _vm.$emit('cancel')}}},[_vm._v(_vm._s(_vm.cancelText))]),_c('Button',{staticClass:"sure",attrs:{"type":"primary","loading":_vm.loading},on:{"click":function($event){return _vm.$emit('confirm')}}},[_vm._v(_vm._s(_vm.confirmText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }